module.exports = __webpack_public_path__ + "img/ios.136a6e1e.png";